// api/devicesApi.ts
import axios from "axios";

const token = btoa(
  `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
);

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: `Basic ${token}`,
  },
});

export const fetchAllDevices = async () => {
  try {
    const response = await axiosInstance.post("/devices", {});
    console.log("✅ Dispositivos obtenidos:", response.data.devices);
    return response.data.devices;
  } catch (error) {
    console.error("❌ Error al obtener dispositivos:", error);
    return [];
  }
};

export const fetchDeviceDetailsBySerial = async (serial) => {
  try {
    const response = await axiosInstance.post("/dep/devices", {
      serials: [serial],
    });
    console.log(`✅ Detalles para ${serial}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error al obtener detalles para ${serial}:`, error);
    return null;
  }
};
